import { isEmpty, max, min } from "lodash";
import moment from "moment";

export const XLABELS = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

export const getWeekTextForLabel = (currentWeek, week) => {
  return currentWeek === week
    ? "this week"
    : currentWeek - 1 === week
    ? "last week"
    : `week ${week}`;
};

const fillArrayWithLength = (arr, len) => {
  const lastItem = arr.at(-1);
  return Array.apply(null, Array(len)).map((val, i) =>
    !!arr?.[i] ? arr[i] : lastItem
  );
};

export const getDataForChart = (
  mainPrices,
  mainVolumes,
  comparePrices,
  compareVolumes,
  currentDay
) => {
  var lastMainPrice = mainPrices?.[0]?.gross_price || "0";
  var lastComparePrice = comparePrices?.[0]?.gross_price || "0";

  var pricesResult = [];
  var comparePricesResult = [];
  var volumesResult = [];
  var compareVolumesResult = [];
  var xDataResult = [];

  for (var i = 0; i < currentDay; i++) {
    var data = {};
    var points = 1;
    var mainPricesOfCurrentDay = mainPrices
      ?.filter((item) =>
        moment(item.last_updated).isSame(moment(mainVolumes[i].to), "date")
      )
      ?.map((item) => item.gross_price);
    if (isEmpty(mainPricesOfCurrentDay)) {
      data = {
        ...data,
        mainPrices: [lastMainPrice],
      };
    } else {
      points = Math.max(points, mainPricesOfCurrentDay.length);
      lastMainPrice = mainPricesOfCurrentDay?.at(-1);
      data = {
        ...data,
        mainPrices: mainPricesOfCurrentDay,
      };
    }

    var comparePricesOfCurrentDay = comparePrices
      ?.filter((item) =>
        moment(item.last_updated).isSame(moment(compareVolumes[i].to), "date")
      )
      ?.map((item) => item.gross_price);
    if (isEmpty(comparePricesOfCurrentDay)) {
      data = {
        ...data,
        comparePrices: [lastComparePrice],
      };
    } else {
      points = Math.max(points, comparePricesOfCurrentDay.length);
      lastComparePrice = comparePricesOfCurrentDay?.at(-1);
      data = {
        ...data,
        comparePrices: comparePricesOfCurrentDay,
      };
    }
    pricesResult = [
      ...pricesResult,
      ...fillArrayWithLength(data.mainPrices, points),
    ];
    comparePricesResult = [
      ...comparePricesResult,
      ...fillArrayWithLength(data.comparePrices, points),
    ];
    volumesResult = [
      ...volumesResult,
      ...fillArrayWithLength([mainVolumes[i]?.sold_stocks], points),
    ];
    compareVolumesResult = [
      ...compareVolumesResult,
      ...fillArrayWithLength([compareVolumes[i]?.sold_stocks], points),
    ];
    xDataResult = [
      ...xDataResult,
      ...fillArrayWithLength([XLABELS[i]], points),
    ];
  }

  return {
    prices: pricesResult.map((val) => parseFloat(val)),
    pricesToCompare: comparePricesResult.map((val) => parseFloat(val)),
    volumes: volumesResult.map((val) => parseFloat(val)),
    volumesToCompare: compareVolumesResult.map((val) => parseFloat(val)),
    xData: xDataResult,
    maxVolume: max([
      ...volumesResult.map((val) => parseFloat(val)),
      ...compareVolumesResult.map((val) => parseFloat(val)),
    ]),
    minPrice: min([
      ...pricesResult.map((val) => parseFloat(val)),
      ...comparePricesResult.map((val) => parseFloat(val)),
    ]),
    maxPrice: max([
      ...pricesResult.map((val) => parseFloat(val)),
      ...comparePricesResult.map((val) => parseFloat(val)),
    ]),
  };
};
